<template>
  <div class="home">
    <div class="banner py-4 mb-3 w-100">
      <div class="container d-flex justify-content-between align-items-center flex-wrap">
        <div><img src="@/assets/image/ai/ai_classroom_text.png" alt="" class=" object-contain"></div>
        <div class="row flex-nowrap">
          <router-link :to="{ 'name': 'ai_records' }" class="col-auto bg-white square d-flex align-items-center px-3 text-xl m-2 whitespace-pre-wrap">
            <p class="text-dark mb-0">查看使用記錄</p><img src="@/assets/image/ai/Arrow_right.png" alt="" class="object-contain">
          </router-link>
        </div>
      </div>
    </div>
    <div class="container" v-if="menuData">
      <div class="row">
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <span class="service-image d-block">
                <img src="@/assets/image/ai/ai_speaking.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
                <img src="@/assets/image/ai/ai_speakingM.png" alt="" class="w-100 h-auto object-contain d-md-none">
              </span>
            </a>
            <div class="p-2">
              <router-link :to="{ 'name': 'chat', 'params': { promptId: value } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold"
                v-for="(value, key, index) in menuData" :key="index">
                <span>
                  <img src="@/assets/image/ai/icon_apple.png" alt="" class="object-contain d-inline">
                  {{ key }}
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <!-- <router-link :to="{ 'name': 'follow', 'params': { promptId: '8ab5296a-4faf-40e5-8f66-95f02929f9a3' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_apple.png" alt="" class="object-contain d-inline">
                  跟讀練習
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link> -->
            </div>
          </div>
        </div>
        <div class="p-2 col-12 col-md-4 font-bold">
          <div class="w-100">
            <a class="d-block p-2">
              <span class="service-image d-block">
                <img src="@/assets/image/ai/ai_letter.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
                <img src="@/assets/image/ai/ai_letterM.png" alt="" class="w-100 h-auto object-contain d-md-none">
              </span>
            </a>
            <div class="p-2">
              <router-link :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'letter' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_letter.png" alt="" class="object-contain d-inline">
                  書信生成
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link  :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'letter' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_speech.png" alt="" class="object-contain d-inline">
                  AI批改
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
          </div>
        </div>
        <div class="p-2 col-12 col-md-4">
          <div class="w-100">
            <a class="d-block p-2">
              <span class="service-image d-block">
                <img src="@/assets/image/ai/ai_speech.png" alt="" class="w-100 h-auto object-contain d-none d-md-block">
                <img src="@/assets/image/ai/ai_speechM.png" alt="" class="w-100 h-auto object-contain d-md-none">
              </span>
            </a>
            <div class="p-2">
              <router-link @click.native="isShowMenu = false" :to="{ 'name': 'ai_assistantMain', 'params': { aiType: 'speech' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_letter.png" alt="" class="object-contain d-inline">
                  演講稿生成
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link :to="{ 'name': 'ai_assistant_correction', 'params': { aiType: 'speech' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <span>
                  <img src="@/assets/image/ai/icon_speech.png" alt="" class="object-contain d-inline">
                  AI批改
                </span>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
              <router-link :to="{ 'name': 'ai_assistant_follow', 'params': { aiType: 'speech' } }" class="d-inline-flex justify-content-between p-2 pointer text-dark font-bold w-100 align-items-center bg-white mb-2 button_item text-xl font-bold">
                <p class="m-0">
                  <img src="@/assets/image/ai/icon_chat.png" alt="" class="object-contain d-inline">
                  跟讀練習
                </p>
                <img src="@/assets/image/ai/Arrow_right_2.png" alt="" class="object-contain d-inline">
              </router-link>
            </div>
            <!-- <a class="d-block p-2 pointer"><img src="@/assets/image/ai/ai_button_03.png" alt="" class="w-100 h-auto object-contain"></a>
            <a class="d-block p-2 pointer"><img src="@/assets/image/ai/ai_button_04.png" alt="" class="w-100 h-auto object-contain"></a> -->
          </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
  import api from '@/store/api'
  export default {
    name: 'Home',
    data () {
      return {
        selectedIdx: 1,
        menuData: null,
        isShowMenu: true
      }
    },
    computed: {
      recentRoute () {
        const { name, params } = this.$route

        if (name === 'ai_assistantIntro') return '使用指南'

        if (name === 'ai_assistantMain') {
          return params.aiType === 'letter' ? '生成書信' :
                params.aiType === 'speech' ? '生成演講稿' : '使用指南'
        }

        if (name === 'ai_assistant_correction') {
          return params.aiType === 'letter' ? 'AI批改' :
                params.aiType === 'speech' ? 'AI批改' : '使用指南'
        }

        if (name === 'chat' && this.menuData) {
          if (params.promptId === this.menuData['商業英語會話']) return '商業情境'
          if (params.promptId === this.menuData['生活英語會話']) return '生活情境'
        }

        if (name === 'ai_assistant_follow') {
          return 'AI批改'
        }

        return '使用指南'
      }
    },
    mounted () {
      this.$store.dispatch('getRemainPoints')
      this.getMenu()
    },
    methods: {
      getMenu () {
        let self = this

        let path = `/ai/categories/list`
        const options = { headers: { 'showLoading': true }}
        api.get(path, options)
        .then((res) => {
          self.menuData = res.data
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
.home {
  background-color: #FAF5EF;
  min-height: 100vh;
}
.banner {
  min-height: 200px;
	background-image:
		url('~@/assets/image/ai/bg.png');
	background-repeat: repeat;
	background-position: center;
}
.square {
  min-height: 140px;
  border-radius: 20px;
  // white-space: nowrap;
}

.service-image {
  position: relative;
  height: 0;
  overflow: hidden;
  border-radius: 6px;
  // 只顯示圖檔上方的標題與插圖，隱藏底部扣點文案。
  padding-top: calc(100% * 78 / 308);
  img {
    position: absolute;
    top: 0;
    left: 0;
  }
  @media (min-width: 768px) {
    padding-top: calc(100% * 280 / 402);
  }
}
a {
  &:hover {
    text-decoration: none !important;
  }
}
.button_item {
  border: 1px solid rgba(94, 160, 221, 1);
  border-radius: 8px;
}
</style>
